import { v1GetWithToken } from './v1'

export const fetchPostList = (params, token) => v1GetWithToken('/creator/post/list', params, token)
